import _ from 'lodash';

import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class NominaPercepcionesCalculator {

  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new NominaPercepcionesCalculator(data);
  }

  get() {
    const totalSueldos = this.getTotalSueldos();
    const totalSeparacionIndemnizacion = this.getTotalSeparacionIndemnizacion();
    const totalJubilacionPensionRetiro = this.getTotalJubilacionPensionRetiro();
    const totalGravado = this.getTotalGravado();
    const totalExento = this.getTotalExento();

    return {
      totalSueldos,
      totalSeparacionIndemnizacion,
      totalJubilacionPensionRetiro,
      totalGravado,
      totalExento
    }
  }

  getTotalSueldos() {
    const exept = [
      '022', // (Prima por Antigüedad)
      '023', // (Pagos por separación)
      '025', // (Indemnizaciones)
      '039', // (Jubilaciones, pensiones o haberes de retiro en una exhibición)
      '044', // (Jubilaciones, pensiones o haberes de retiro en parcialidades).
    ];

    const total = _.sumBy(this._getPercepciones(exept), (item) => {
      return parseFloat(item.ImporteGravado) + parseFloat(item.ImporteExento);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalSeparacionIndemnizacion() {
    const only = [
      '022', // Prima por Antigüedad,
      '023', // Pagos por separación
      '025', // Indemnizaciones
    ];

    const total = _.sumBy(this._getPercepciones(only, 1), (item) => {
      return parseFloat(item.ImporteGravado) + parseFloat(item.ImporteExento);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalJubilacionPensionRetiro() {
    const only = [
      '039', // Jubilaciones, pensiones o haberes de retiro en una exhibición
      '044', // Jubilaciones, pensiones o haberes de retiro en parcialidades
    ];

    const total = _.sumBy(this._getPercepciones(only, 1), (item) => {
      return parseFloat(item.ImporteGravado) + parseFloat(item.ImporteExento);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalGravado() {
    const total = _.sumBy(this._getPercepciones(), (item) => {
      return parseFloat(item.ImporteGravado);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  getTotalExento() {
    const total = _.sumBy(this._getPercepciones(), (item) => {
      return parseFloat(item.ImporteExento);
    });

    return total !== undefined ? DecimalForGlobals.make(total).toFixed() : undefined;
  }

  _getPercepciones(haystack = [], flag = 0) {
    if (flag === 1) {
      return this.data.filter((item) => {
        return haystack.indexOf(item.TipoPercepcion) !== -1;
      });
    }

    return this.data.filter((item) => {
      return haystack.indexOf(item.TipoPercepcion) === -1;
    });
  }

}

export default NominaPercepcionesCalculator;